import { MenuType } from '@/shared/types';

/**
 * todo: clearify the tabs for each menu
 * todo: dynamic DB should be maintained and fetch menu through api
 */
export const MENU_ITEMS: MenuType[] = [
  {
    key: '1',
    label: 'Dashboard',
    link: '/dashboard',
    icon: 'dashboard',
    display: true,
  },

  {
    key: '2',
    label: 'Contacts',
    link: '/contacts',
    icon: 'user',
    display: true,
  },
  {
    key: '3',
    label: 'Properties',
    link: '/property/list',
    icon: 'home',
    display: true,
  },
  {
    key: '4',
    label: 'Mortgage',
    icon: 'mortgage',
    display: true,
    access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
    children: [
      {
        key: '4.1',
        label: 'Leads',
        link: '/lead',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '4.2',
        label: 'Broker',
        link: '/application/broker',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '4.3',
        label: 'Credit Analyst',
        link: '/application/credit-analyst',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '4.4',
        label: 'Legacy Gravity Form',
        link: '/application/website-oa',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '4.5',
        label: 'Infynity',
        link: '/infynity',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '4.6',
        label: 'Lender List',
        link: '/lender-list',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      // {
      //   key: '3.6',
      //   label: 'Compliance Note',
      //   link: '/application/note/compliance',
      //   display: false,
      // },
      {
        key: '4.7',
        label: 'Mortgage Webinar',
        link: '/application/webinar/mortgage-webinar',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
    ],
  },
  // {
  //   key: '4',
  //   label: 'Purchase',
  //   link: '/purchase',
  //   icon: 'fileDone',
  //   display: true,
  // },
  // {
  //   key: '5',
  //   label: 'Refinance',
  //   link: '/refinance',
  //   icon: 'fileAdd',
  //   display: true,
  // },
  // {
  //   key: '6',
  //   label: 'Notes',
  //   icon: 'fileAdd',
  //   display: true,
  //   children: [
  //     {
  //       key: '6.1',
  //       label: 'Compliance Note',
  //       link: '/note/compliance',
  //       display: true,
  //     },
  //   ],
  // },

  {
    key: '9',
    label: 'Profile',
    link: '/profile',
    icon: 'user',
    display: false,
  },
  {
    key: '10',
    label: 'Tax',
    icon: 'tax',
    display: true,
    access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
    children: [
      {
        key: '10.1',
        label: 'Tax Leads',
        link: '/tax/leads',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      {
        key: '10.2',
        label: 'Diagnostic',
        link: '/tax/diagnostic',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      {
        key: '10.3',
        label: 'Tax File Summary',
        link: '/tax/deals',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      {
        key: '10.4',
        label: 'Returns Preparation',
        link: '/tax/returns',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      {
        key: '10.5',
        label: 'CGT Preparation',
        link: '/tax/cgt/list',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      // {
      //   key: '10.4',
      //   label: 'Tax Toolkit',
      //   link: '/tax/toolkit',
      //   icon: 'check',
      //   display: true,
      // },
    ],
  },
  // {
  //   key: '11',
  //   label: 'Conveyancing',
  //   icon: 'app',
  //   display: true,
  //   children: [
  //     {
  //       key: '11.1',
  //       label: 'Leads',
  //       link: '/conveyancing/leads',
  //       icon: 'check',
  //       display: true,
  //     },
  //     {
  //       key: '11.2',
  //       label: 'Deals',
  //       link: '/conveyancing/deals',
  //       icon: 'check',
  //       display: true,
  //     },
  //   ],
  // },
  {
    key: '12',
    label: 'Tools',
    icon: 'tool',
    display: true,
    // access: { anyOf: ['admin', 'marketing'] },
    children: [
      {
        key: '12.1',
        label: 'Search Websites',
        link: '/tools/search',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '12.2',
        label: 'COS Extracted',
        link: '/tools/cos-extracted',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '12.3',
        label: 'Generate CSA Pdf',
        link: '/tools/csa-pdf-generate',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '12.4',
        label: 'Odin Extensions',
        link: '/tools/odin-extensions',
        display: true,
        access: { anyOf: ['tax_processor', 'tax_admin', 'admin'] },
      },
      {
        key: '12.5',
        label: 'Infynity OTP',
        link: '/tools/infynity-otp',
        display: true,
        access: { anyOf: ['mortgage_ca', 'mortgage_ems', 'admin'] },
      },
      {
        key: '12.6',
        label: 'Document Translation',
        link: '/tools/document-translation',
        display: true,
        access: { anyOf: ['mortgage_ca', 'mortgage_ems', 'admin'] },
      },
      {
        key: '12.7',
        label: 'Run Extraction',
        link: '/tools/run-extraction',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
    ],
  },

  {
    key: '16',
    label: 'Document Invites',
    icon: 'fileDone',
    display: true,
    access: {
      anyOf: ['admin', 'mortgage_admin'],
    },
    children: [
      {
        key: '16.1',
        label: 'Requests',
        link: '/documents-invite',
        display: true,
        access: {
          anyOf: [
            'tax_processor',
            'tax_admin',
            'mortgage_ems',
            'mortgage_ca',
            'admin',
          ],
        },
      },
      {
        key: '16.2',
        label: 'Templates',
        link: '/documents-invite/templates',
        display: true,
        access: {
          anyOf: [
            'tax_processor',
            'tax_admin',
            'mortgage_ems',
            'mortgage_ca',
            'admin',
          ],
        },
      },
    ],
  },
  {
    key: '13',
    label: 'Data Analytics',
    icon: 'data',
    display: true,
    access: { anyOf: ['admin', 'marketing'] },
    children: [
      {
        key: '13.1',
        label: 'Websites',
        link: '/data-analytics/website',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '13.2',

        label: 'SQL Dashboard',
        link: '/data-analytics/sql-dashboard',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '13.3',
        label: 'Meta Dashboard',
        link: '/data-analytics/meta-dashboard',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '13.5',
        label: 'Meta Dashboard V2',
        link: '/data-analytics/meta-dashboard-v2',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '13.6',
        label: 'Free Content Dashboard',
        link: '/data-analytics/free-content-dashboard',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
      {
        key: '13.4',
        label: 'Meta Performance',
        link: '/data-analytics/meta-performance',
        display: true,
        access: { anyOf: ['admin', 'marketing'] },
      },
    ],
  },
  {
    key: '17',
    label: 'Marketing Dashboard',
    link: '/marketing',
    icon: 'data',
    display: true,
    // Same role keys the backend enforces on POST /v1/embed/ticket. Kept
    // top-level rather than nested under Data Analytics: that section is gated
    // on `marketing`, and filterMenuByRoles keeps a parent whose child is
    // allowed, so nesting would surface the whole section to data_analyst.
    access: { anyOf: ['admin', 'data_analyst'] },
  },
  {
    key: '18',
    label: 'Agents',
    link: '/agents',
    icon: 'agents',
    display: true,
    // Shown only when the agent service says this user may open the page.
    showIf: 'agents_page',
  },
  {
    key: '14',
    label: 'Access Control',
    // link: '/access-control',
    icon: 'security',
    display: true,
    access: { anyOf: ['admin', 'mortgage_ca_lead'] },
    children: [
      {
        key: '9.1',
        label: 'Users',
        link: '/access-control/users',
        display: true,
        access: { anyOf: ['admin', 'mortgage_ca_lead'] },
      },
      {
        key: '9.2',
        label: 'Roles',
        link: '/access-control/roles',
        display: true,
        access: { anyOf: ['admin'] },
      },
      {
        key: '9.3',
        label: 'Permissions',
        link: '/access-control/permissions',
        display: true,
        access: { anyOf: ['admin'] },
      },
    ],
  },
  {
    key: '15',
    label: 'Settings',
    icon: 'setting',
    display: true,
    access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
    children: [
      {
        key: '15.1',
        label: 'Client Portal',
        link: '/settings/client-portal',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.2',
        label: 'Lenders',
        link: '/settings/lenders',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.3',
        label: 'Rates & Calculations',
        link: '/settings/rates',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.4',
        label: 'Expat Products Compare',
        link: '/settings/expat-products-compare',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.5',
        label: 'Foreigner Products Compare',
        link: '/settings/foreigner-products-compare',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.6',
        label: 'Prompt Schemas',
        link: '/settings/prompt-schemas',
        display: true,
        access: { anyOf: ['mortgage_ems', 'mortgage_ca', 'admin'] },
      },
      {
        key: '15.8',
        label: 'Concept Library',
        link: '/settings/concept-library',
        display: true,
        // Deliberately no `access`: filterMenuByRoles keeps a parent whose
        // child is allowed, so every role sees Settings > Concept Library
        // while the other Settings children stay gated.
      },
      {
        key: '15.7',
        label: 'Knowledge Base',
        link: '/settings/knowledge-base',
        display: true,
        access: { anyOf: ['admin'] },
      },
    ],
  },
];
